"use client";

import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/navigation";
import lottie from "lottie-web";

import services from "@/store/services";
import Icons from "@/assets/icons";
import apis from "@/api";

import styles from "./styles.module.scss";

function PurchaseTimeByCP(props) {
  const user = useSelector((state) => state?.user?.users);

  const [hasUnlockedMoreTime, setHasUnlockedMoreTime] = useState(false);
  const [showCelebrate, setShowCelebrate] = useState(false);
  const [loading, setLoading] = useState(false);
  const celebrateRef = useRef(null);

  const { toggleLimitReached } = props;
  const dispatch = useDispatch();
  const router = useRouter();

  const handleProceed = async () => {
    try {
      setLoading(true);
      const response = await apis.updateUserEarnedDayPoints();

      if (response.status === 200) {
        setShowCelebrate(true);
        setHasUnlockedMoreTime(true);
        dispatch(services.fetchPoints(user));
      } else {
        dispatch(services.failureAlert(response.data.error));
      }
    } catch (err) {
      console.error("API error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (showCelebrate) {
      const anim = lottie.loadAnimation({
        container: celebrateRef.current,
        renderer: "svg",
        animationData: Icons.Confetti,
        loop: true,
        autoplay: true,
      });

      const timeout = setTimeout(() => {
        anim.destroy();
        setShowCelebrate(false);
      }, 3000); // display for 3 seconds

      return () => {
        anim.destroy();
        clearTimeout(timeout);
      };
    }
  }, [showCelebrate]);

  return hasUnlockedMoreTime ? (
    <div className={styles["ra-video-warning-auth"]}>
      <div>
        <h3 className={styles["vd-error-message"]}>✅ You're All Set!</h3>
        <h3 className={styles["vd-error-message"]}>
          Great! You've successfully unlocked 30 more minutes of focused
          learning. 🎉
        </h3>
        <h3 className={styles["vd-error-message"]}>
          Keep going, your dedication is what sets you apart💪
        </h3>
        <article className={styles["video-warning-actions"]}>
          <button
            className={styles["proceed-btn"]}
            onClick={() => toggleLimitReached()}
          >
            Continue Learning
          </button>
        </article>
      </div>
    </div>
  ) : (
    <div className={styles["ra-video-warning-auth"]}>
      <div>
        <h3 className={styles["vd-error-message"]}>
          ⏳ Time&apos;s Up! Unlock More Learning 🚀
        </h3>

        <h3 className={styles["vd-error-message"]}>
          You&apos;ve exhausted today&apos;s learning limit ⏲️
          <br /> Want to continue learning for another 30 minutes?
        </h3>

        <h3 className={styles["vd-error-message"]}>
          Use <span>5 existing CipherPoints to get 30 more minutes </span> of
          learning.
        </h3>

        <article className={styles["video-warning-actions"]}>
          <button
            className={styles["proceed-btn"]}
            onClick={() => handleProceed()}
          >
            {loading ? "Processing..." : "Okay, Proceed"}
          </button>
          <button
            className={styles["cancel-btn"]}
            onClick={() => router.push("/campus-invite")}
          >
            Skip the Wait
          </button>
        </article>
      </div>
    </div>
  );
}

export default PurchaseTimeByCP;
